"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function chance(percent) {
  return Math.random() * 100 <= percent;
}

exports.chance = chance;